import { useMutation, useQueryClient } from '@tanstack/react-query';

import { loadVoucherUserSnapshot } from '~/components/Vouchers/loadVoucherUserSnapshot';

import { type ListAllVoucherUsersQuery, listAllVoucherUsers } from '~/services/PromoService';

import { allVoucherUsersQueryKeys } from './useListAllVoucherUsers';

export function useLoadMatchingVoucherUsers() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      query,
      total,
      onProgress,
    }: {
      query: ListAllVoucherUsersQuery;
      total: number;
      onProgress: (loaded: number) => void;
    }) =>
      loadVoucherUserSnapshot(
        query,
        total,
        async (pageQuery) => {
          const response = await queryClient.fetchQuery({
            queryKey: [...allVoucherUsersQueryKeys.all, 'bulk-snapshot', pageQuery],
            queryFn: ({ signal }) => listAllVoucherUsers(pageQuery, { signal }),
            staleTime: 0,
            retry: false,
          });
          return response.result;
        },
        onProgress,
      ),
  });
}
